import AccordionCustom from "@components/Accordion/AccordionCustom";
import CatalogChatbotSection from "@components/CatalogChatbotSection";
import CatalogHeroSection from "@components/CatalogHeroSection";
import ImageGrid from "@components/ImageGrid";
import FeatureCardSection from "@components/LandingPageComponents/CardSection";
import TestimonialSection from "@components/LandingPageComponents/TestimonialSection";
import Testmon from "@components/LandingPageComponents/testmon-pay";
import ClientLogos from "@components/new-ui/ClientLogos";
import NewLayout from "@components/new-ui/Layout";
import YellowCTAhref from "@components/yellowCTAhref";
import icon1 from "public/ai1.png";
import icon2 from "public/ai2.png";
import icon3 from "public/ai3.png";
import React from "react";
import faqSchema from "components/faqSchema/build-your-shop-on-whatsapp.json";
import Head from "next/head";

const sections = [
    {
        title: "Instant Inquiry",
        icon: icon1,
        title2: "Instant Inquiry",
        desc: "Empower your customers to effortlessly inquire about product information, such as availability, sizes, colors, and more, directly through WhatsApp, fostering quick communication.",
        img: "https://assets.gallabox.com/gb-home/catalog/inquiry.png",
    },
    {
        title: "Order Placement",
        icon: icon3,
        title2: "Order Placement",
        desc: "Enable customers to place orders directly from the WhatsApp interface by specifying product quantities and preferences. Streamline the purchase process eliminating the need to visit websites separately.",
        img: "https://assets.gallabox.com/gb-home/catalog/placement.png",
    },
    {
        title: "Payment Collection",
        icon: icon2,
        title2: "Payment Collection",
        desc: "Remove friction in the buyer journey by seamlessly integrating payment options within the WhatsApp Chat interface. Boost your conversion rates by enabling customers to easily make purchases and complete transactions without leaving the chat window.",
        img: "https://assets.gallabox.com/gb-home/catalog/collection.png",
    },

    {
        title: "Order Tracking",
        icon: icon3,
        title2: "Order Tracking",
        desc: "Stay in the loop with your customers on WhatsApp and provide real-time updates on their orders and shipping status. Provide a convenient ordering experience and address their queries 24x7 using Gallaboax's no-code chatbots.",
        img: "https://assets.gallabox.com/gb-home/catalog/tracking.png",
    },
    {
        title: "Recommendations ",
        icon: icon2,
        title2: "Personalized Recommendations",
        desc: "Streamline your communication process to offer personalized customer experiences, such as tailored product suggestions that match their preferences, previous purchases, browsing history, and more, to increase resonance and customer satisfaction.",
        img: "https://assets.gallabox.com/gb-home/catalog/recommendations.png",
    },
];

const catalogPage: React.FC = () => {
    return (
        <NewLayout
            title="Whatsapp Store Builder | Create Your Online Shop"
            description="Build and manage your store with WhatsApp Store Builder. Upload products, automate orders, and boost sales effortlessly."
            canonical="https://gallabox.com/build-your-shop-on-whatsapp"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/catalog/catalog-og.png" }}
        >
            <Head>
                <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
            </Head>
            <CatalogHeroSection botIconSrc="https://assets.gallabox.com/gb-home/catalog/herosection.png" title="Launch Your Shop with WhatsApp Store Builder" />

            <div className="lg:max-w-7xl mx-auto">
                <p className="text-base text-center font-normal py-2">Trusted by 10,000+ businesses</p>
                <ClientLogos />
            </div>

            <FeatureCardSection
                subTitle="Product creation & management"
                imageURl="https://assets.gallabox.com/gb-home/catalog/creation.png"
                title="Set up product catalogs and start selling on WhatsApp in no time"
                description="Create your WhatsApp Shop instantly by uploading them to WhatsApp via Google Sheets. Take your customers seamlessly from browsing to buying on WhatsApp."
            />

            <FeatureCardSection
                isImageRightSide
                subTitle="Categorization & bundling"
                imageURl="https://assets.gallabox.com/gb-home/catalog/categorization.png"
                title="Categorize products. Create bundles based on buying patterns"
                description="Organize your products into categories on WhatsApp, so your customers can easily find what they’re looking for. Understand buying patterns and bundle products on the go to boost your sales and conversion rates."
            />

            <FeatureCardSection
                subTitle="Chatbots & flows"
                imageURl="https://assets.gallabox.com/gb-home/catalog/flows.png"
                title="Offer a seamless shopping experience from end-to-end"
                description="Reduce recurring conversations, and engage your customers and prospects around the clock with our simple drag-and-drop chatbots. Automatically insert the catalogs into the conversation, and put your sales on autopilot."
            />

            <CatalogChatbotSection sections={sections} />

            <Testmon
                TestimonialSectionPropsData={[
                    {
                        img: "https://assets.gallabox.com/gb-home/catalog/inquiry.png",
                        title: "Instant Inquiry",
                        desc: "Empower your customers to effortlessly inquire about product information, such as availability, sizes, colors, and more, directly through WhatsApp, fostering quick communication.",
                    },
                    {
                        img: "https://assets.gallabox.com/gb-home/catalog/placement.png",
                        title: "Order Placement",
                        desc: "Enable customers to place orders directly from the WhatsApp interface by specifying product quantities and preferences. Streamline the purchase process eliminating the need to visit websites separately.",
                    },
                    {
                        img: "https://assets.gallabox.com/gb-home/catalog/collection.png",
                        title: "Payment Collection",
                        desc: "Remove friction in the buyer journey by seamlessly integrating payment options within the WhatsApp Chat interface. Boost your conversion rates by enabling customers to easily make purchases and complete transactions without leaving the chat window.",
                    },
                    {
                        img: "https://assets.gallabox.com/gb-home/catalog/tracking.png",
                        title: "Order Tracking",
                        desc: "Stay in the loop with your customers on WhatsApp and provide real-time updates on their orders and shipping status. Provide a convenient ordering experience and address their queries 24x7 using Gallaboax's no-code chatbots.",
                    },
                    {
                        img: "https://assets.gallabox.com/gb-home/catalog/recommendations.png",
                        title: "Personalized Recommendations",
                        desc: " Streamline your communication process to offer personalized customer experiences, such as tailored product suggestions that match their preferences, previous purchases, browsing history, and more, to increase resonance and customer satisfaction.",
                    },
                ]}
            />

            <YellowCTAhref
                buttonText="Start Free Trial"
                customText={<div className="text-2xl md:text-3xl font-bold text-yellow-800">Put your sales on autopilot with Gallabox!</div>}
            />

            <TestimonialSection
                TestimonialSectionPropsData={[
                    {
                        companyImg: "https://assets.gallabox.com/gb-home/travelmite-logo.svg",
                        avatarImg: "https://assets.gallabox.com/gb-home/travelmite-comp-logo.png",
                        headerTitle: "Gallabox solves our pain points, such as unattended customer & agent chat visibility",
                        nameText: "Vaseem Ahmed",
                        professionText: "Founder & CEO, Travelmite",
                    },
                    {
                        companyImg: "https://assets.gallabox.com/gb-home/estr-logo.png",
                        avatarImg: "https://assets.gallabox.com/gb-home/estr-owner.png",
                        headerTitle: "The integration process is incredibly straightforward, with no hassles whatsoever. Furthermore, the support provided is excellent.",
                        nameText: "Rohit Shukla",
                        professionText: "Founder, ESTR Holidays",
                    },
                ]}
            />
            <ImageGrid />

            <YellowCTAhref buttonText="Get Started Today" customText={<div className="text-2xl md:text-3xl font-bold text-yellow-800">Boost your sales on WhatsApp today</div>} />

            <section className="max-w-6xl py-4 mx-auto px-4">
                <div className="flex flex-col justify-center lg:gap-4 gap-2 items-center pb-6">
                    <p className="lg:text-4xl text-3xl text-center font-bold text-gray-700">Build-your-shop-on-whatsapp : Frequently Asked Questions</p>
                </div>
                <AccordionCustom
                    title="build-your-shop-on-whatsapp"
                    items={[
                        {
                            question: "1. Can I sell products directly through WhatsApp using the WhatsApp Store Builder?",
                            answer: "Yes, you can! With the WhatsApp Store Builder, you can create product catalogs that showcase your entire range. Customers can easily browse, view details, and make purchases directly through WhatsApp, making the buying process seamless and highly convenient.",
                        },
                        {
                            question: "2. Does WhatsApp Store Builder support both physical and digital products? ",
                            answer: "Yes, Gallabox's WhatsApp Store Builder supports both physical and digital products. It allows businesses to create product catalogs with physical goods and services and even includes features for selling digital products and subscriptions. For example, you can create a product catalog with items like clothing, electronics, and even digital downloads.",
                        },
                        {
                            question: "3. How do I integrate my existing products into WhatsApp Store Builder?",
                            answer: "You can start by creating a catalog of your products. Then, you can connect the products with your e-commerce platform.This allows your existing product listings to sync directly with the WhatsApp Store Builder, making them instantly available for customers to browse and purchase via WhatsApp.",
                        },
                        {
                            question: "4. Can I customize my store's look and feel with WhatsApp Store Builder?",
                            answer: "Yes, with Gallabox’s WhatsApp Store Builder, you can fully customize your store’s look and feel to match your brand identity. Tailor layouts, colors, and content to suit your audience’s preferences while ensuring a consistent, on-brand shopping experience.",
                        },
                        {
                            question: "5. Can WhatsApp Store Builder handle payment processing for my store?",
                            answer: "Yes, the WhatsApp Store Builder can handle payment processing by integrating seamlessly with popular payment gateways. With Gallabox, you can connect your store to existing tools like CRMs and payment processors, enabling smooth, secure, and automated transactions on WhatsApp.",
                        },
                        {
                            question: "6. Is it possible to offer discounts or promotions through WhatsApp Store Builder?",
                            answer: "You can offer discounts through Gallabox’s WhatsApp Store Builder. Using features like Coupon Code Templates and Click-to-WhatsApp ads, businesses can send personalised discount codes and promote offers via WhatsApp. This helps in boosting engagement and driving more sales directly on WhatsApp.",
                        },
                        {
                            question: "7. How secure is the payment and order processing on WhatsApp Store Builder?",
                            answer: "Both payments and order processing on Gallabox are safe, as they are encrypted end-to-end and are PCI-compliant (Payment Card Industry). It includes a WhatsApp Order Summary that allows for easy tracking, customer details, payment status, and other relevant information in a structured format. ",
                        },
                        {
                            question: "8. Can I manage inventory and stock levels through WhatsApp Store Builder?",
                            answer: "Integrating the WhatsApp store builder with an inventory management tool enables real-time stock tracking, prevents overselling, and ensures accurate product availability, helping you manage inventory efficiently and streamline operations.",
                        },
                        {
                            question: "9. Does WhatsApp Store Builder allow for order tracking and delivery updates?",
                            answer: "Yes, Gallabox’s WhatsApp store builder along with WhatsApp Business API helps you track different details like order date, customer information, order status, and payment status that are necessary to provide delivery updates. It makes order processing easy for both the buyer and the seller.",
                        },
                        {
                            question: "10. Can I integrate WhatsApp Store Builder with my existing eCommerce platform or CRM?",
                            answer: "Yes, you can integrate WhatsApp Store Builder with your existing eCommerce platform or CRM. Gallabox allows seamless integration with CRMs such as Zoho, HubSpot, LeadSquared, Odoo, Kylas, CoreFactors, and LEDSAK, as well as eCommerce platforms like Shopify for streamlined operations.",
                        },
                        {
                            question: "11. Can I offer customer support through WhatsApp Store Builder after a sale?",
                            answer: "With WhatsApp Business API, you can integrate Gallabox’s Store Builder with chatbots, forms, and a shared inbox to engage post-purchase, offer support, and collect feedback—unlike the manual support on regular WhatsApp, this setup connects seamlessly with your CRM or helpdesk.",
                        },
                    ]}
                />
            </section>
        </NewLayout>
    );
};

export default catalogPage;
